import gql from 'graphql-tag';

export const getJobQL = gql`
    query ($id: ID!) {
        job (id: $id) {
            id
            date
            description
            client {
                id
                name
            }
            outlets {
                id
                name
                retailer {
                    id
                    name
                    logo {
                        id
                        url
                    }
                }
            }
            products {
                id
                name
                intrackProduct {
                    id
                    category {
                        id
                        canonicalName
                    }
                }
            }
        }
    }
`;

export interface JobResult {
  id: string;
  outletId: string;
  outletName: string;
  productId: string;
  productName: string;
  price: number | null;
  note: string | null;
  isOos: boolean;
  isInStorePromo: boolean;
}

export const getJobResultQL = gql`
    query ($id: ID!) {
        jobResult (id: $id) {
            id
            outletId
            outletName
            productId
            productName
            price
            note
            isOos
            isInStorePromo
        }
    }
`;
